import { useEffect } from 'react';
import { Outlet } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { appConfig } from "../apiConfig";
import { useLanguage } from "../context/LanguageProvider";

export default function DashboardLayout() {
  const { t } = useLanguage();

  useEffect(() => {
      document.title = `${appConfig.name} | ${t('layout.web.page_title')}`;
    
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.href = `/images/${appConfig.slug}-fav.png`;
      }
  }, []);

  return (
    <div dir="rtl" className="website">
      <Header />
      <main className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}